import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, renderSlot as _renderSlot } from "vue"
import _imports_0 from '@/assets/logo.svg'


const _hoisted_1 = { class: "vtmn-h-screen vtmn-flex vtmn-flex-col vtmn-overflow-hidden" }
const _hoisted_2 = { class: "vtmn-h-16 vtmn-bg-white vtmn-border-b vtmn-border-gray-200 vtmn-flex vtmn-items-center vtmn-px-4 vtmn-shrink-0 vtmn-justify-between vtmn-z-50 vtmn-relative" }
const _hoisted_3 = { class: "vtmn-flex vtmn-items-center" }
const _hoisted_4 = { class: "vtmn-flex vtmn-items-center vtmn-gap-3" }
const _hoisted_5 = { class: "vtmn-font-bold vtmn-text-lg vtmn-text-blue-800" }
const _hoisted_6 = { class: "vtmn-flex vtmn-flex-1 vtmn-overflow-hidden vtmn-relative" }
const _hoisted_7 = { class: "vtmn-flex vtmn-items-center vtmn-h-16 vtmn-transition-all vtmn-duration-300 vtmn-border-b vtmn-border-gray-200 vtmn-p-0 vtmn-overflow-hidden" }
const _hoisted_8 = { class: "icon-container flex-shrink-0" }
const _hoisted_9 = {
  class: "vtmn-h-8 vtmn-w-8 vtmn-rounded-full vtmn-bg-blue-700 vtmn-text-white vtmn-flex vtmn-items-center vtmn-justify-center vtmn-font-bold vtmn-text-sm",
  "data-testid": "user-initials"
}
const _hoisted_10 = { class: "vtmn-font-bold vtmn-text-sm vtmn-text-gray-900" }
const _hoisted_11 = { class: "vtmn-text-xs vtmn-text-gray-500" }
const _hoisted_12 = { class: "vtmn-flex-1 vtmn-py-4 vtmn-space-y-1 vtmn-overflow-x-hidden vtmn-capitalize" }
const _hoisted_13 = { class: "icon-container" }
const _hoisted_14 = ["title"]
const _hoisted_15 = { class: "vtmn-border-t vtmn-border-gray-200 vtmn-p-0 vtmn-overflow-hidden" }
const _hoisted_16 = ["title"]
const _hoisted_17 = ["title"]
const _hoisted_18 = { class: "vtmn-flex-1 vtmn-overflow-y-auto vtmn-bg-gray-50" }

import { ref, computed, watch, onMounted, onUnmounted } from "vue";
import useAuth from "@/modules/oauth/composables/useAuth";
import fedidService from "../../modules/oauth/services/FedidService";
import { useRoute } from "vue-router";
import { ROLE_APPS, ROLE_NAMES } from "@/modules/oauth/constants/roles";
import useKioskMode from "@/composables/useKioskMode";

type MenuItem = { label: string; routeName: string; icon: string; allowedRoles: string[]; prefix: string };


export default /*@__PURE__*/_defineComponent({
  __name: 'NavbarComp',
  setup(__props) {

const route = useRoute();
const {
  isKioskModeActive,
  isKioskRoute,
  activateKioskMode,
  deactivateKioskMode,
  syncKioskModeFromStorage,
  KIOSK_ALLOWED_ROUTE_NAMES,
} = useKioskMode();

const isDesktopExpanded = ref(false);
const isMobileOpen = ref(false);
const isMobileScreen = ref(false);
const isSidebarHidden = ref(false);
const isKioskRouteActive = computed(() => isKioskRoute(route.path));

const currentModuleTitle = computed(() => {
  const parts = route.path.split("/").filter(Boolean);
  const moduleName = parts.length > 0 ? parts[0] : "hda";

  const titles: Record<string, string> = {
    hda: "HDA",
    planning: "PLANNING",
    configuration: "CONFIGURATION",
    visitor: "VISITOR",
    bookings: "BOOKINGS",
  };
  return titles[moduleName] || moduleName.toUpperCase();
});

const checkScreenSize = () => {
  isMobileScreen.value = window.innerWidth < 768;
  if (!isMobileScreen.value) {
    isMobileOpen.value = false;
  }
};

onMounted(() => {
  checkScreenSize();
  window.addEventListener("resize", checkScreenSize);
  globalThis.addEventListener("keydown", handleKeyDown);
  syncKioskModeFromStorage();
  isSidebarHidden.value = false;
});
onUnmounted(() => {
  window.removeEventListener("resize", checkScreenSize);
  globalThis.removeEventListener("keydown", handleKeyDown);
});

const menuIconClass = computed(() => {
  if (isMobileScreen.value && isMobileOpen.value) {
    return "vtmx-close-line";
  }
  return "vtmx-menu-line";
});

const sidebarClasses = computed(() => {
  if (isMobileScreen.value) {
    return [
      "vtmn-fixed",
      "vtmn-top-16",
      "vtmn-left-0",
      "vtmn-bottom-0",
      "vtmn-w-full",
      isMobileOpen.value ? "vtmn-translate-x-0" : "-vtmn-translate-x-full",
    ];
  } else {
    if (isSidebarHidden.value) {
      return ["vtmn-w-0", "vtmn-border-none"];
    }
    return ["vtmn-relative", "vtmn-translate-x-0", isDesktopExpanded.value ? "vtmn-w-72" : "vtmn-w-16"];
  }
});

const handleToggle = () => {
  if (isMobileScreen.value) {
    isMobileOpen.value = !isMobileOpen.value;
  } else if (isSidebarHidden.value) {
    isSidebarHidden.value = false;
  } else {
    isDesktopExpanded.value = !isDesktopExpanded.value;
  }
};

const onActivateKioskMode = () => {
  if (isKioskModeActive.value) {
    return;
  }
  activateKioskMode();
  isSidebarHidden.value = false;
};

const handleKeyDown = (event: KeyboardEvent) => {
  if (event.key === "F9") {
    event.preventDefault();
    if (isKioskModeActive.value) {
      deactivateKioskMode();
      isSidebarHidden.value = false;
    }
  }
};

const handleLinkClick = () => {
  if (isMobileScreen.value) {
    isMobileOpen.value = false;
  } else {
    isDesktopExpanded.value = false;
  }
};

const closeMobileSidebar = () => {
  isMobileOpen.value = false;
};

const closeDesktopSidebar = () => {
  if (!isMobileScreen.value && isDesktopExpanded.value) {
    isDesktopExpanded.value = false;
  }
};

const user = ref({ name: "", email: "", job: "" });
const hdaRoles = ref<string[]>([]);
const dassistRoles = ref<string[]>([]);
const { userInfo, getRolesByAppName } = useAuth();

const onLogout = () => fedidService.logout();

const userInitials = computed(() => {
  if (!user.value.name) return "U";
  const names = user.value.name.split(" ");
  let initials = names[0].substring(0, 1).toUpperCase();
  if (names.length > 1) initials += names[names.length - 1].substring(0, 1).toUpperCase();
  return initials;
});

const updateUserData = () => {
  if (userInfo.value) {
    user.value.name = userInfo.value.displayName || "";
    user.value.job = userInfo.value?.jobname || "";
    hdaRoles.value = getRolesByAppName(ROLE_APPS.HDA_ROLES)?.map((role) => role.role) || [];
    dassistRoles.value = getRolesByAppName(ROLE_APPS.DASSIST_ROLES)?.map((role) => role.role) || [];
  }
};
watch(userInfo, updateUserData);
updateUserData();

const menuConfig = [
  {
    label: "hda",
    routeName: "collaborator",
    icon: "vtmx-home-line",
    allowedRoles: [
      ROLE_NAMES.HDA_IT_SUPERADMIN,
      ROLE_NAMES.HDA_SUPERADMIN,
      ROLE_NAMES.HDA_OPERATOR,
      ROLE_NAMES.WAREHOUSEMANAGER,
      ROLE_NAMES.ECONOMIC,
    ],
    prefix: "/hda",
    appContext: ROLE_APPS.HDA_ROLES,
  },
  {
    label: "visitors",
    routeName: "visitors",
    icon: "vtmx-group-line",
    allowedRoles: [ROLE_NAMES.VISITORS, ROLE_NAMES.VISITORS_ADMIN, ROLE_NAMES.DASSIST_SUPERADMIN],
    prefix: "/visitors",
    appContext: ROLE_APPS.DASSIST_ROLES,
  },
  {
    label: "delays",
    routeName: "delays",
    icon: "vtmx-time-line",
    allowedRoles: [ROLE_NAMES.VISITORS, ROLE_NAMES.DELAYS_ADMIN, ROLE_NAMES.DASSIST_SUPERADMIN],
    prefix: "/delays",
    appContext: ROLE_APPS.DASSIST_ROLES,
  },
  {
    label: "bookings",
    routeName: "bookingsHome",
    icon: "vtmx-calendar-check-line",
    allowedRoles: [ROLE_NAMES.DASSIST_SUPERADMIN],
    prefix: "/bookings",
    appContext: ROLE_APPS.DASSIST_ROLES,
  },
  {
    label: "configuration",
    routeName: "configuration",
    icon: "vtmx-settings-line",
    allowedRoles: [ROLE_NAMES.HDA_SUPERADMIN, ROLE_NAMES.VISITORS_ADMIN, ROLE_NAMES.DASSIST_SUPERADMIN],
    prefix: "/configuration",
    appContext: "BOTH",
  },
];

const isItemActive = (item: MenuItem) => {
  return route.path.startsWith(item.prefix);
};

const visibleMenuItems = computed(() => {
  if (!hdaRoles.value && !dassistRoles.value) return [];

  const roleFiltered = menuConfig.filter((item) => {
    if (item.allowedRoles.length === 0) return true;

    let rolesToCheck: string[] = [];
    if (item.appContext === ROLE_APPS.HDA_ROLES) {
      rolesToCheck = hdaRoles.value || [];
    } else if (item.appContext === ROLE_APPS.DASSIST_ROLES) {
      rolesToCheck = dassistRoles.value || [];
    } else if (item.appContext === "BOTH") {
      rolesToCheck = [...(hdaRoles.value || []), ...(dassistRoles.value || [])];
    }

    return item.allowedRoles.some((requiredRole) => rolesToCheck.includes(requiredRole));
  });

  if (isKioskModeActive.value) {
    return roleFiltered.filter((item) => KIOSK_ALLOWED_ROUTE_NAMES.includes(item.routeName as "visitors" | "delays"));
  }

  return roleFiltered;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          onClick: _withModifiers(handleToggle, ["stop"]),
          "data-testid": "btn-toggle",
          class: "vtmn-mr-4 vtmn-p-2 vtmn-rounded hover:vtmn-bg-gray-100 vtmn-text-gray-600 vtmn-flex vtmn-items-center"
        }, [
          _createElementVNode("span", {
            class: _normalizeClass([menuIconClass.value, "vtmn-text-2xl"])
          }, null, 2)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[1] || (_cache[1] = _createElementVNode("img", {
            src: _imports_0,
            alt: "logo decathlon",
            class: "vtmn-h-7"
          }, null, -1)),
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "vtmn-h-6 vtmn-w-px vtmn-bg-gray-300 mx-2" }, null, -1)),
          _createElementVNode("span", _hoisted_5, _toDisplayString(currentModuleTitle.value), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (isMobileOpen.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            onClick: closeMobileSidebar,
            class: "vtmn-fixed vtmn-inset-0 vtmn-bg-opacity-50 vtmn-z-20 md:vtmn-hidden transition-opacity",
            "data-testid": "mobile-overlay"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("aside", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
        class: _normalizeClass(["vtmn-bg-white vtmn-border-r vtmn-border-gray-200 vtmn-flex vtmn-flex-col vtmn-transition-all vtmn-duration-300 vtmn-ease-in-out vtmn-z-30 vtmn-overflow-hidden", sidebarClasses.value]),
        "data-testid": "sidebar"
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, _toDisplayString(userInitials.value), 1)
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["vtmn-flex vtmn-flex-col vtmn-justify-center vtmn-transition-opacity vtmn-duration-300 vtmn-whitespace-nowrap", { 'vtmn-opacity-100': isDesktopExpanded.value || isMobileOpen.value, 'vtmn-opacity-0': !isDesktopExpanded.value }])
          }, [
            _createElementVNode("p", _hoisted_10, _toDisplayString(user.value.name), 1),
            _createElementVNode("p", _hoisted_11, _toDisplayString(user.value.job), 1)
          ], 2)
        ]),
        _createElementVNode("nav", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleMenuItems.value, (item) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: item.routeName,
              to: { name: item.routeName },
              class: _normalizeClass(["nav-item group", { 'nav-item-active': isItemActive(item) }]),
              title: !isDesktopExpanded.value && !isMobileOpen.value ? (_ctx.$te(item.label) ? _ctx.$t(item.label) : item.label) : '',
              onClick: handleLinkClick
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", {
                    class: _normalizeClass([item.icon, 'vtmn-text-2xl group-hover:vtmn-text-blue-700'])
                  }, null, 2)
                ]),
                _createElementVNode("span", {
                  class: _normalizeClass(["nav-text", {
                'vtmn-opacity-100': isDesktopExpanded.value || isMobileOpen.value,
                'vtmn-opacity-0': !isDesktopExpanded.value && !isMobileOpen.value,
              }])
                }, _toDisplayString(_ctx.$te(item.label) ? _ctx.$t(item.label) : item.label), 3)
              ]),
              _: 2
            }, 1032, ["to", "class", "title"]))
          }), 128))
        ]),
        (!_unref(isKioskModeActive))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              href: "https://support.decathlon.net/saw/ess/offeringPage/107014470",
              target: "_blank",
              "data-testid": "support-link",
              class: "nav-item group vtmn-w-full hover:vtmn-bg-gray-100",
              title: !isDesktopExpanded.value && !isMobileOpen.value ? _ctx.$t('ask_support') : ''
            }, [
              _cache[3] || (_cache[3] = _createElementVNode("div", { class: "icon-container" }, [
                _createElementVNode("span", { class: "vtmx-customer-service-line vtmn-text-2xl vtmn-text-gray-600 group-hover:vtmn-text-blue-700" })
              ], -1)),
              _createElementVNode("span", {
                class: _normalizeClass(["nav-text vtmn-text-gray-600", { 'vtmn-opacity-100': isDesktopExpanded.value || isMobileOpen.value, 'vtmn-opacity-0': !isDesktopExpanded.value }])
              }, _toDisplayString(_ctx.$t("ask_support")), 3)
            ], 8, _hoisted_14))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            onClick: onLogout,
            class: "nav-item group vtmn-w-full hover:vtmn-bg-red-50",
            "data-testid": "btn-logout",
            title: !isDesktopExpanded.value && !isMobileOpen.value ? _ctx.$t('logout') : ''
          }, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "icon-container" }, [
              _createElementVNode("span", { class: "vtmx-logout-line vtmn-text-2xl vtmn-text-red-600 group-hover:vtmn-text-red-700" })
            ], -1)),
            _createElementVNode("span", {
              class: _normalizeClass(["nav-text vtmn-text-red-600", { 'vtmn-opacity-100': isDesktopExpanded.value || isMobileOpen.value, 'vtmn-opacity-0': !isDesktopExpanded.value }])
            }, _toDisplayString(_ctx.$t("logout")), 3)
          ], 8, _hoisted_16)
        ])
      ], 2),
      _createElementVNode("main", {
        class: "vtmn-flex-1 vtmn-relative vtmn-flex vtmn-flex-col vtmn-min-w-0",
        "data-testid": "main-content",
        onClick: closeDesktopSidebar
      }, [
        (!isMobileScreen.value && isKioskRouteActive.value)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: onActivateKioskMode,
              class: _normalizeClass(["vtmn-absolute vtmn-top-6 vtmn-left-0 vtmn-z-40 vtmn-h-10 vtmn-w-6 vtmn-overflow-hidden vtmn-border vtmn-border-l-0 vtmn-rounded-r vtmn-shadow-md vtmn-flex vtmn-items-center vtmn-justify-center vtmn-transition-colors vtmn-duration-300", 
            _unref(isKioskModeActive)
              ? 'vtmn-text-blue-700'
              : 'vtmn-bg-white vtmn-border-gray-200 vtmn-text-gray-500 hover:vtmn-text-blue-700'
          ]),
              "data-testid": "btn-toggle-visibility",
              title: _unref(isKioskModeActive) ? 'Modo quiosco activo: pulse F9 para mostrar menú' : 'Activar modo quiosco'
            }, [...(_cache[5] || (_cache[5] = [
              _createElementVNode("span", { class: "vtmx-lock-line vtmn-text-xl" }, null, -1)
            ]))], 10, _hoisted_17))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_18, [
          _renderSlot(_ctx.$slots, "default")
        ])
      ])
    ])
  ]))
}
}

})